export default __webpack_public_path__ + "static/media/on-point-solar-logo.f5c385c4.png";